/** @file Helpers to reset the editor to a fresh unsaved play. */
import { appStore } from "./state.js";
import { createInitialTokens, createInitialScene, DRAW_COLORS } from "./play.js";
import { historyReset } from "./history.js";
import { startNewPlay } from "./current-play.js";
import { markEditorClean } from "./editor-dirty.js";

/**
 * Reset all editor-owned play state to a blank, unsaved default board.
 * Keeps the current field transform so an already-mounted stage can redraw immediately.
 */
export function resetEditorToNewPlay() {
  const tokens = createInitialTokens();
  startNewPlay();
  appStore.set({
    tokens,
    drawings: [],
    scenes: [createInitialScene(tokens)],
    activeSceneIndex: 0,
    selectedDrawingId: null,
    tool: "select",
    drawColor: DRAW_COLORS[0],
  });
  historyReset();
  markEditorClean();
}
